module.exports = __webpack_public_path__ + "img/6-white.75976ce2.svg";